import React from 'react';
import doctor from '../../../assets/images/doctor.png';
import appointment from '../../../assets/images/appointment.png';
import { Link } from 'react-router-dom';

const AppointmentCard = () => {
    return (
        <div className='mt-16 lg:mt-36' style={{background:`url(${appointment})`}}>
            <div className="hero ">
                <div className="hero-content flex-col lg:flex-row">
                    <img src={doctor} className="-mt-40 hidden lg:block lg:w-1/2 rounded-lg shadow-2xl" alt='' />
                    <div>
                        <h1 className="text-xl text-secondary font-bold">Appointment</h1>
                        <h1 className="text-4xl text-white font-bold">Make an appointment Today</h1>
                        <p className="py-6 text-white">Booking an appointment at Doctor Portal is quick and convenient. Our friendly team helps you schedule visits that fit your busy lifestyle. Whether it’s a routine check-up or a specialized treatment, we ensure timely care. Your dental health is our priority, every step of the way.</p>
                        <Link to='/appointment'><button className="btn btn-secondary text-white mt-3">Make Appointment</button></Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentCard;